/**
 * @fileoverview Logout Animation Overlay Component
 *
 * Displays a fullscreen overlay during the logout process.
 */

import React from 'react';
import { FiCheck, FiLogOut } from 'react-icons/fi';

/**
 * Logout Overlay Component
 *
 * @param {Object} props - Component props
 * @param {boolean} props.show - Whether to show the overlay
 * @param {boolean} props.complete - Whether logout is complete
 * @returns {JSX.Element|null} Logout overlay component or null
 */
const LogoutOverlay = ({ show, complete }) => {
  if (!show) {
    return null;
  }

  return (
    <div className={`lp-logout-overlay ${complete ? 'fade-out' : ''}`}>
      <div className="lp-logout-content">
        {complete ? (
          <FiCheck className="lp-logout-icon success" />
        ) : (
          <FiLogOut className="lp-logout-icon" />
        )}
        <h2 className="lp-logout-title">
          {complete ? 'Signed Out' : 'Signing Out...'}
        </h2>
        <p className="lp-logout-message">
          {complete ? 'See you next time!' : 'Please wait'}
        </p>
      </div>
    </div>
  );
};

export default LogoutOverlay;
